import { Component, OnInit } from '@angular/core';
import { BaseModalContainer, ModalContainerService, ModalService, UserService } from 'yt-ng-framework';
import { ActivatedRoute } from '@angular/router';
import { Okrug } from './okrug';

@Component({
  selector: 'app-okrug',
  templateUrl: './okrug.component.html'
})
export class OkrugComponent extends BaseModalContainer<Okrug> implements OnInit {
  constructor(
    protected modalContainerService: ModalContainerService<Okrug>,
    protected activatedRoute: ActivatedRoute,
    protected modalService: ModalService,
    protected userService: UserService
  ) {
    super(modalContainerService, activatedRoute, modalService, userService);
  }

  ngOnInit() {
    
  }

}
